<template>
  <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
</template>

<script>
import MyGridLayout from "@/components/tools/MyGridLayout";
export default {
  name: "Dataset_state_grid",
  components: {MyGridLayout},
  data(){
    return{
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "MarkerCard", data:{datasetID: '', Array: ''} },
      ],
      index: 0,
      formData: {
        datasetID: '',
        Array:  '',
        State: 'Angiogenesis',
      },
      groundtruth_source: '',
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        }
      },
    }
  },
  props:{
    asyncData:{
      classification_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      fine_annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      celltype_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      major_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      minor_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      subset_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },

      // type:String,  //类型可以定义
      // default:''  //默认是空值
      // type:Object,  default () {return {}}
    },
    asynGround: String,
    datasetInfo: Array
  },
  provide() {
    return {
      addNewCardMethod: this.addNewCardHandle,
    };
  },
  mounted() {
    this.echart_info = this.asyncData
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.Array = this.datasetInfo[0].name
    this.groundtruth_source= this.asynGround
    this.initLayoutData()
  },
  methods:{
    initLayoutData(){
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: 'state'+index.toString(),
          type: "TruthImageCard",
          data:{
            datasetID: this.formData.datasetID,
            groundtruth_source: this.asynGround
          }
        },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'state'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'state'+index.toString(),
        type: "StateCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
        },
      },)
      index++;
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'state'+index.toString(),
        type: "AddNewCard",
      },)
      index++;

      this.layoutData = temp_layout
      // console.log(this.layoutData)
      this.index = index
      this.isGridShow = true
    },
    addNewCardHandle() {
      let index = this.index;
      let temp_json = {
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'state'+index.toString(),
        type: "StateCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
        },
      };
      index++;
      this.index = index
      this.layoutData.splice(index, 0, temp_json)
      // console.log(this.layoutData)
    },
  }
}
</script>

<style scoped>

</style>
